/**
 * CopyButtonIcon
 * @returns {import("react").ReactNode} - SVG Icon
 */
function CopyButtonIcon() {
  return (
    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1.38965" y="0.5" width="12.3333" height="11.6667" rx="3.5" stroke="currentColor" />
      <rect
        x="4.89893"
        y="3.8335"
        width="12.3333"
        height="11.6667"
        rx="3.5"
        fill="#F3F3F3"
        stroke="currentColor"
      />
    </svg>
  );
}

export default CopyButtonIcon;
